/* corrects anchor tags with no targets */
export default function correctAnchorTarget(str) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = str;
    // Previously using tempDiv.querySelectorAll('a').forEach It's not browser compaitable
    // source: https://stackoverflow.com/questions/41054259/how-can-i-make-queryselectorall-or-foreach-work-in-firefox
    const anchors = tempDiv.getElementsByTagName('a');
    if (anchors.length > 0) {
        for (let i = 0; i < anchors.length; i++) {
            anchors[i].setAttribute('target', '_blank');
        }
    }
    return tempDiv.innerHTML;
};

